import { render, staticRenderFns } from "./KitsView.vue?vue&type=template&id=43d74ee0&scoped=true&"
import script from "./KitsView.vue?vue&type=script&lang=ts&"
export * from "./KitsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d74ee0",
  null
  
)

export default component.exports